import { useDispatch } from 'react-redux'
import { toggleLoader } from '../features/mapSlice'
import type { POI, POIType } from '../models/POI'
import { CloseBotButtonClick } from '../utils/botUtils'
import React from 'react'
import { getPoiColor } from '../utils/poiUtils'
import { RETORIK_URL } from '../utils/globalUtils'
import {
  setDetailOpennedByMap,
  setDisplayPOIFinished
} from '../features/poiSlice'
import { useLocaleStore, sendActivity } from '@davi-ai/retorik-framework'
import translation from '../translations/poi.json'
import { WebChatActivity } from 'botframework-webchat-core'

interface POIDetailProps {
  poi: POI
  poiClose: Function
}

const POIDetail = (props: POIDetailProps): JSX.Element => {
  const poi = props.poi
  const dispatch = useDispatch()
  const locale = useLocaleStore((state) => state.locale)

  const showMoreHandler = (poi: POI): void => {
    console.log('event trigger ==> ' + poi.name)

    CloseBotButtonClick()
    // Display Loader
    dispatch(toggleLoader({ loading: true }))
    // Store information that POI detail is openned by the map to handle the return
    dispatch(setDetailOpennedByMap({ detailOpennedByMap: true }))
    dispatch(setDisplayPOIFinished({ displayPOIFinished: false }))

    sendActivity({
      channelData: {
        postBack: true
      },
      text: undefined,
      type: 'message',
      value: {
        identifier: poi.contentItemId,
        name: 'hospitality.showPoiById',
        searchLabel: ''
      }
    } as WebChatActivity)
  }

  return (
    <>
      <div className='infoPOIPane'>
        <span className='poiTitle'>{poi.name}</span>
        <span className='poiClose' onClick={(): void => props.poiClose()}>
          X
        </span>
        {poi.address && <span className='poiAddress'>{poi.address}</span>}
        {poi.phone && <span className='poiPhone'>{`\u260E ${poi.phone}`}</span>}
        {poi.imageURL && (
          <span className='poiPhoto'>
            <img src={`${RETORIK_URL}${poi.imageURL}`} alt={poi.name} />
          </span>
        )}
        <span className='poiDesc'>{poi.description}</span>
        <div
          className={`${poi.imageURL ? 'flex-break-with-photo' : 'flex-break'}`}
        />
        <button
          onClick={(): void => showMoreHandler(poi)}
          className={`button_${getPoiColor(poi.type as POIType)} poiButton`}>
          {translation[locale]?.showmore || translation['fr-FR'].showmore}
        </button>
      </div>
    </>
  )
}

export { POIDetail }
